let supportedStyles = null;
function isCssPropertySupports(property) {
  if (!supportedStyles) {
    const div = document.createElement('div');
    supportedStyles = div.style;
  }
  return property in supportedStyles;
}
function isWebkitLineClampSupports() {
  return isCssPropertySupports('webkitLineClamp') || isCssPropertySupports('-webkit-line-clamp');
}

export { isWebkitLineClampSupports as i };
